import * as LiquidGlass from './index.js'

if (typeof window !== 'undefined') {
  window.LiquidGlass = Object.assign(window.LiquidGlass || {}, LiquidGlass)
}

export * from './index.js'
